import HttpClientManager from '@/business/core/clients/http/helpers/manager.helper';

import type { ICityResponse } from '@/business/modules/city/city.model';

class CityRepository {
	httpClient: any;
	static #instance: CityRepository;
	readonly CITY: string = 'Cities';

	private constructor() {
		this.httpClient = HttpClientManager.getInstance();
	}

	public static getInstance(): CityRepository {
		if (!CityRepository.#instance) {
			CityRepository.#instance = new CityRepository();
		}

		return CityRepository.#instance;
	}

	getCities(): Promise<ICityResponse[]> {
		return this.httpClient(`${this.CITY}`, {
			method: 'get',
		});
	}
}

export default CityRepository;
